import config from '@shared/config/env'
import axios, { AxiosInstance } from 'axios'

export const FAKE_URL = 'http://localhost:3005/'
export const BACKEND_URL = `${config.getBackendUrl()}/app`
export const BACKEND_USER_URL = `${config.getBackendUrl()}/auth`
export const BACKEND_AUTH_URL = `${config.getBackendUrl()}/auth`

export const backendInstance: AxiosInstance = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Authorization: ''
  },
  timeout: 180000
})

export const _fakeInstance: AxiosInstance = axios.create({
  baseURL: FAKE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 180000
})

export const userInstance: AxiosInstance = axios.create({
  baseURL: BACKEND_USER_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Authorization: ''
  },
  timeout: 180000
})

export const authInstance: AxiosInstance = axios.create({
  baseURL: BACKEND_AUTH_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 180000
})

export type FakePaginationResponse<T> = {
  first: number
  prev: null
  next: number
  last: number
  pages: number
  items: number
  data: T
}

export type PageMetaType = {
  page: number
  size: number
  total: number
}

export type PaginationResponse<T> = {
  items: T
  page: number
  size: number
  total: number
}
